// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"uM-z","carouselContainer":"vM-z"};